import { createFileRoute } from '@tanstack/react-router'
import TicketsListPage from '@/spa/pages/TicketsListPage'
import { routeErrorComponent } from '../_shared/RouteError'

export const Route = createFileRoute('/tickets/')({
  component: TicketsListPage,
  errorComponent: routeErrorComponent,
})
